<template>
  <section class="section">
    <div class="container">
      <div class="cr_wrapper">
        <div class="trainer-signup-background">
          <div class="feature_image">
            <img class="img-fluid" alt="" :src="options.headers[value].img" />
          </div>
          <div>
            <h4 class="img-text">{{ options.headers[value].imgText }}</h4>
          </div>
        </div>
        <div class="cr_item">
          <div class="cr_item_content">
            <h1>{{ options.headers[value].title }}</h1>
            <h2>{{ options.headers[value].subtitle }}</h2>
            <ul class="cr_steps">
              <li
                :key="item.title"
                v-for="(item, index) in options.headers"
                v-bind:class="{ active: value === index }"
              ></li>
            </ul>
            <div
              :key="item.title"
              v-for="(item, index) in options.headers"
              v-show="value === index"
            >
              <transition name="component-fade" mode="out-in">
                <slot :name="'step-' + index"></slot>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UStepper',
  props: ['options', 'value'],
  methods: {
    Next() {
      this.value++
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value)
    },
  },
}
</script>
<style scoped>
.cr_wrapper .feature_image {
  padding: 0;
}
/* .trainer-signup-background {

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
  align-items: center;
  justify-items: center;
} */
.img-text {
  font-family: 'Open Sans';
  color: whitesmoke;
  font-size: 1.2rem;
  letter-spacing: -1.2px;
}
@media (max-width: 767.98px) {
  .trainer-signup-background {
    grid-template-columns: 1fr;
  }
  .img-text {
    font-size: 14px;
    padding: 1em;
  }
}
</style>
